export default "__VITE_ASSET__BI4U3dkO__"